/* THE ILLUMINATEE - colour-swatch crossfade (dissolve through white).
   Picking a different Color fades the current photo out to white and the new one
   back in, holding the veil until the incoming photo is loaded and decoded.
   Finds the Color fieldset via its <legend> - still correct in Horizon 4.1.4.
   Tweakables at the top: FADE_OUT, HOLD, FADE_IN, MAX_HOLD, COLOR. */
(function () {
  'use strict';
  if (window.__illColorXfade) return;        // guard against an accidental double-paste
  window.__illColorXfade = true;

  /* ----------------------------- tweakables ----------------------------- */
  var FADE_OUT = 220;                          // current photo -> white
  var HOLD     = 80;                           // min fully-white dwell before checking
  var FADE_IN  = 300;                          // white -> new photo
  var MAX_HOLD = 1800;                         // safety cap waiting for the new photo
  var COLOR    = '#ffffff';                    // the wash colour
  var EASE_OUT = 'cubic-bezier(0.4, 0, 1, 1)'; // accelerate into white
  var EASE_IN  = 'cubic-bezier(0, 0, 0.2, 1)'; // decelerate out of white
  /* ---------------------------------------------------------------------- */

  function prefersReduce(){
    return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Every product-image viewport on the page (covers desktop + mobile galleries).
  function viewports(){
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-testid="product-information-media"]')
    );
  }

  // Is this control part of the COLOR option group (the one that drives images)?
  function isColorControl(node){
    if (!node || !node.closest) return false;
    var fs = node.closest('fieldset');
    if (!fs) return false;
    var label = fs.querySelector('legend, .form__label, label');
    return !!(label && /colou?r/i.test(label.textContent || ''));
  }

  // The current gallery image inside the stable media column, plus how much
  // of that image is visible (0–1). The v6 slideshow viewport can be wider
  // than the square photo, so visibility is measured against the photo itself.
  function bestVisible(view){
    var gallery  = view.querySelector('media-gallery');
    var viewport = gallery && gallery.querySelector('slideshow-container');
    if (!viewport) return { img: null, ratio: 0 };

    var box = viewport.getBoundingClientRect();
    var best = null, bestArea = 0, bestOwnArea = 1;
    var imgs = viewport.querySelectorAll('slideshow-slide img, .product-media__image');
    if (!imgs.length) imgs = viewport.querySelectorAll('img');

    for (var i = 0; i < imgs.length; i++){
      if (imgs[i].closest('.ill-xfade')) continue;
      var r = imgs[i].getBoundingClientRect();
      var w = Math.max(0, Math.min(r.right, box.right) - Math.max(r.left, box.left));
      var h = Math.max(0, Math.min(r.bottom, box.bottom) - Math.max(r.top, box.top));
      var area = w * h;
      if (area > bestArea){
        bestArea = area;
        bestOwnArea = Math.max(1, r.width * r.height);
        best = imgs[i];
      }
    }
    return { img: best, ratio: bestArea / bestOwnArea };
  }

  // Capture the outgoing photo and its exact frame inside the stable media
  // column so the frozen copy cannot stretch or zoom before the fade.
  function snapshot(img, view){
    if (!img || !view) return null;
    var cs = getComputedStyle(img);
    var ir = img.getBoundingClientRect();
    var vr = view.getBoundingClientRect();
    var clip = img.closest('slideshow-container');
    return {
      src:    img.currentSrc || img.src,
      srcset: img.getAttribute('srcset') || '',
      sizes:  img.getAttribute('sizes') || '',
      fit:    cs.objectFit || 'cover',
      pos:    cs.objectPosition || 'center',
      radius: clip ? getComputedStyle(clip).borderRadius : cs.borderRadius,
      frame: {
        left: ir.left - vr.left - (view.clientLeft || 0) + view.scrollLeft,
        top: ir.top - vr.top - (view.clientTop || 0) + view.scrollTop,
        width: ir.width,
        height: ir.height
      }
    };
  }

  // Build (once per viewport) the overlay = frozen still + white wash.
  function overlayFor(view){
    if (view._illXfade) return view._illXfade;
    if (getComputedStyle(view).position === 'static') view.style.position = 'relative';
    var root   = document.createElement('div'); root.className = 'ill-xfade';
    var frozen = document.createElement('img'); frozen.className = 'ill-xfade__frozen';
    frozen.alt = ''; frozen.setAttribute('aria-hidden', 'true'); frozen.decoding = 'async';
    var wash   = document.createElement('div'); wash.className = 'ill-xfade__wash';
    wash.style.setProperty('--ill-xfade-color', COLOR);
    root.appendChild(frozen);   // frozen still  (middle layer)
    root.appendChild(wash);     // white veil     (top layer, paints over the still)
    view.appendChild(root);
    return (view._illXfade = { root: root, frozen: frozen, wash: wash, seq: 0 });
  }

  function positionOverlay(o, snap){
    var f = snap && snap.frame;
    if (!f) return;
    o.root.style.inset = 'auto';
    o.root.style.left = f.left + 'px';
    o.root.style.top = f.top + 'px';
    o.root.style.width = f.width + 'px';
    o.root.style.height = f.height + 'px';
    o.root.style.borderRadius = snap.radius || '0px';
  }

  // Clear the veil to reveal the (now ready) live photo.
  function reveal(o, my){
    if (my !== o.seq) return;
    o.frozen.style.opacity = '0';            // drop the still (already hidden under the veil)
    o.wash.style.transition = 'opacity ' + FADE_IN + 'ms ' + EASE_IN;
    o.wash.style.opacity = '0';
    setTimeout(function(){
      if (my !== o.seq) return;
      o.frozen.removeAttribute('src');        // release the still
      o.frozen.removeAttribute('srcset');
    }, FADE_IN + 60);
  }

  // While the veil is white, wait until the INCOMING photo has actually replaced
  // the outgoing one (different image, filling the frame, loaded) and decoded —
  // then reveal it. A timeout guarantees we never hold the veil indefinitely.
  function holdUntilReady(view, snap, o, my, whiteUpAt){
    (function attempt(){
      if (my !== o.seq) return;              // a newer colour click took over
      var v = bestVisible(view), img = v.img;
      var changed  = img && (!snap || (img.currentSrc || img.src) !== snap.src);
      var settled  = changed && v.ratio > 0.9 && img.complete && img.naturalWidth > 0;
      var timedOut = (performance.now() - whiteUpAt) > MAX_HOLD;
      if (settled || timedOut){
        var go = function(){ reveal(o, my); };
        if (img && img.decode){ img.decode().then(go).catch(go); } else { go(); }
      } else {
        setTimeout(attempt, 50);             // poll (timer-based, so it survives bg tabs)
      }
    })();
  }

  // Run the dissolve on one viewport, using a snapshot of the OUTGOING photo.
  function crossfade(view, snap){
    var o  = overlayFor(view);
    positionOverlay(o, snap);
    var my = ++o.seq;                          // a newer colour click cancels this run

    if (snap){
      if (snap.srcset) o.frozen.srcset = snap.srcset; else o.frozen.removeAttribute('srcset');
      if (snap.sizes)  o.frozen.sizes  = snap.sizes;
      o.frozen.style.objectFit = snap.fit;
      o.frozen.style.objectPosition = snap.pos;
      o.frozen.src = snap.src;                 // same URL is cached -> paints immediately
    }

    // Start state: outgoing photo solid on top, veil clear.
    o.frozen.style.transition = 'none';
    o.wash.style.transition   = 'none';
    o.frozen.style.opacity = snap ? '1' : '0';
    o.wash.style.opacity   = '0';
    void o.root.offsetWidth;                   // commit the start state before animating

    // Phase 1 — the outgoing photo dissolves to white.
    o.wash.style.transition = 'opacity ' + FADE_OUT + 'ms ' + EASE_OUT;
    o.wash.style.opacity = '1';
    var whiteUpAt = performance.now();

    // Phase 2 — once the veil is white, wait for the new photo, then reveal it.
    setTimeout(function(){
      if (my !== o.seq) return;
      holdUntilReady(view, snap, o, my, whiteUpAt);
    }, FADE_OUT + HOLD);
  }

  // Grab the outgoing photo the INSTANT a swatch is pressed — before the theme
  // can swap it. (Keyboard selection has no pointer event; the capture-phase
  // 'change' handler below still runs before the theme's own handler, so the
  // snapshot taken there is still the outgoing photo.)
  var pending = null, pendingTimer = null;
  document.addEventListener('pointerdown', function (e){
    if (prefersReduce() || !isColorControl(e.target)) return;
    pending = viewports().map(function (v){ return { v: v, snap: snapshot(bestVisible(v).img, v) }; });
    clearTimeout(pendingTimer);
    pendingTimer = setTimeout(function (){ pending = null; }, 900);
  }, true);

  // Fire the dissolve when the colour actually changes.
  document.addEventListener('change', function (e){
    if (prefersReduce() || !isColorControl(e.target)) return;
    var list = pending; pending = null; clearTimeout(pendingTimer);
    if (list){
      list.forEach(function (p){ crossfade(p.v, p.snap); });
    } else {
      viewports().forEach(function (v){ crossfade(v, snapshot(bestVisible(v).img, v)); });
    }
  }, true); // capture phase: run before the theme swaps the image
})();
